import React from "react";

import { getProgress } from "../../../../ProgressBarView/util/getProgress";
import { useProgressBarContext } from "../../../context/ProgressBarContext";
import { Bar } from "../components/Bar";

import { BreakpointIcons } from "./BreakpointIcons";
import { BreakpointLabels } from "./BreakpointLabels";

export const ProgressBar = () => {
  const { state, config } = useProgressBarContext();

  const getWeight = (index: number) => {
    if (state.breakpoints.length == 1) {
      return 1;
    } else {
      return 1 / (state.breakpoints.length - 1);
    }
  };

  const progress = getProgress(state, getWeight);

  return (
    <div className={"ig-content"}>
      {config.desktop.widget.styles.breakpoint.hideText ? null : (
        <BreakpointLabels />
      )}
      <BreakpointIcons />
      <Bar progress={progress} />
    </div>
  );
};
